/** 
 * Action Types
 */

export const SET_ANSWER = 'SET_ANSWER';
export const SET_ANSWERS = 'SET_ANSWERS';
export const RESET_ANSWERS = 'RESET_ANSWERS';


/** WEBPACK FOOTER **
 ** ./src/constants/answerTypes.js
 **/